import React from 'react'

class ArticlesClass {
  
    constructor(title, brief, slug, totalReaction, dateAdded){
        this.title = title;
        this.brief = brief;
        this.slug = slug;
        this.dateAdded = dateAdded;
        this.totalReaction = totalReaction;
    }

}

export default ArticlesClass
